<template>
    <div >
        <transactions-statistics></transactions-statistics>
        <kt-datatable v-if="user" v-bind="datatableProps"></kt-datatable>
    </div>
</template>

<script>
import $ from 'jquery'
import { ApiUrl } from '@/common/api.service'
import columns from './../../transaction/datatable/columns'
import actions from './../../transaction/datatable/actions'
import { AuthorizationHeader } from '@/common/jwt.service'
import { mapGetters } from 'vuex'
import transactionStatistics from './transactions-statistics'

export default {
    components: {
        'transactions-statistics': transactionStatistics
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapGetters('user', [
            'user', 'status'
        ]),
        datatableProps() {
            return {
                withPanel: false,
                id: "user_transaction_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('transaction'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                user_id: this.user.id
                            },
                        },
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: columns,
            }
        }
    },
}
</script>

<style>

</style>